import styled from '@emotion/styled';
import { Grid } from '@kc-console/common-ui';

import { useRefinedConsoleMenuState } from '../../../../hooks';
import CategorySection from '../Content/CategorySection';

const MegaMenuGlobalSidebarMenuItem = () => {
  const { allServices } = useRefinedConsoleMenuState();

  return (
    <MegaMenuGlobalSidebarMenuItemWrapper display={'flex'} gap={'8px'} flexDirection={'column'}>
      {allServices.map(category => {
        return <CategorySection key={category.name} category={category} type={'all'} />;
      })}
    </MegaMenuGlobalSidebarMenuItemWrapper>
  );
};

export default MegaMenuGlobalSidebarMenuItem;

const MegaMenuGlobalSidebarMenuItemWrapper = styled(Grid)`
  overflow: auto;
`;
